export default __webpack_public_path__ + "be6c5e5099aad53529faf8f7295e7f7b.png";